import { Button, Form, Row, Typography } from 'antd';
import { AppProps } from 'presentation/App';
import { BUYER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { FormCheckBox } from 'presentation/components/form/FormCheckBox.component';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';

export const CU06202Page = (props: AppProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { settlementId } = useParams();
    const [form] = Form.useForm();
    const userSlice = useAppSelector((state) => state.user);
    const [btnDisable, setBtnDisable] = React.useState<boolean>(true);
    const [displayDate, setDisplayDate] = React.useState<string[]>([]);
    const { masterUseCase } = props;

    useEffect(() => {
        if (settlementId) {
            getInitInfo();
        }
    }, [settlementId]);

    const submitForm = async () => {
        const payload = {
            settlementId: Number(settlementId),
            scheduleAdjustmentDiv: userSlice.implementerClassification ?? BUYER_CLASSIFICATION,
            change_flg: form.getFieldValue('change_flg') ? 1 : 0,
        };
        try {
            dispatch(startFetching());
            const response = await masterUseCase.confirmSettingProperty(payload);
            if (response.status == 200) {
                openSuccessNoti({ description: getMessage('S0323') });
                navigate(-1);
            }
        } catch (error) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    const getInitInfo = async () => {
        if (settlementId) {
            try {
                dispatch(startFetching());
                const params = {
                    settlementId: Number(settlementId),
                    scheduleAdjustmentDiv:
                        userSlice.implementerClassification ?? BUYER_CLASSIFICATION,
                };
                const response = await masterUseCase.getConfirmSettingProperty(params);
                const responseDate = response?.result;
                const responseDateArr: string[] = [];
                responseDateArr.push(formatDate(responseDate?.preferred01Date));
                // responseDateArr.push(
                //     formatDate(
                //         responseDate?.preferred02Date,
                //         responseDate?.preferred02Time,
                //     ),
                // );
                // responseDateArr.push(
                //     formatDate(
                //         responseDate?.preferred03Date,
                //         responseDate?.preferred03Time,
                //     ),
                // );
                setDisplayDate(responseDateArr.filter((item) => item !== ''));
            } catch (error) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        }
    };

    const formatDate = (date?: string, time?: string) => {
        if (date && time) {
            return (
                commonHelpers.formatDate(date, DATE_FORMAT.FORMAT_DATE_WITH_DAY) +
                ' ' +
                time.replace('-', '〜')
            );
        }
        if (date) {
            return commonHelpers.formatDate(date, DATE_FORMAT.FORMAT_DATETIME_WITH_DAY);
        }
        return '';
    };

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch((err) => {
                setBtnDisable(err.errorFields.length > 0);
            });
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="cu-043-01"
        >
            <PageTitle title="司法書士最終確認日時の確定" showTypeSelect={false} />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'hidden',
                }}
            >
                <Form
                    onValuesChange={onChangeForm}
                    onFinish={submitForm}
                    form={form}
                    id="top-form"
                    className="flex justify-center items-center w-full"
                >
                    <Row className="flex-col w-1/2">
                        <Row className="mb-[12px]">
                            <Typography.Text className="text-white text-sm">
                                確認日時
                            </Typography.Text>
                        </Row>
                        {displayDate?.map((item, index) => {
                            return (
                                <Row key={index} className="mb-[8px]">
                                    <Typography.Text className="text-white text-base font-bold leading-5">
                                        {item}
                                    </Typography.Text>
                                </Row>
                            );
                        })}
                        <Row className="mb-[16px]">
                            <Typography.Text className="text-white text-sm">
                                所要時間は5分程度です。
                            </Typography.Text>
                        </Row>
                        <Row className="mb-[24px]">
                            <FormCheckBox
                                name="change_flg"
                                required
                                showErrorMessage={false}
                                options={[
                                    {
                                        value: 1,
                                        label: '上記の時間で変更ありません。',
                                    },
                                ]}
                                className="mb-0"
                            />
                        </Row>
                        <Row className="justify-center mb-[30px]">
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ width: '100%', height: 56 }}
                                disabled={btnDisable}
                            >
                                送信する
                            </Button>
                        </Row>
                    </Row>
                </Form>
            </section>
        </div>
    );
};
